import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { useLang } from '../i18n/LangContext';
import { SectionEyebrow, SectionTitle, FadeIn, StaggerList, StaggerItem } from '../components/Animated';

const COVERS = [
  'https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NTYxODh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBzb2Z0d2FyZSUyMGRhc2hib2FyZHxlbnwwfHx8fDE3ODIyMTQwMTN8MA&ixlib=rb-4.1.0&q=85',
  'https://images.pexels.com/photos/27141316/pexels-photo-27141316.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  'https://images.pexels.com/photos/12198534/pexels-photo-12198534.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  'https://images.unsplash.com/photo-1622737133809-d95047b9e673?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHwzZCUyMGFic3RyYWN0JTIwc2hhcGVzJTIwZGFya3xlbnwwfHx8fDE3ODIyMTQwMTN8MA&ixlib=rb-4.1.0&q=85',
  'https://images.pexels.com/photos/14963655/pexels-photo-14963655.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  'https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NTYxODh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBzb2Z0d2FyZSUyMGRhc2hib2FyZHxlbnwwfHx8fDE3ODIyMTQwMTN8MA&ixlib=rb-4.1.0&q=85',
];

const PortfolioPage = () => {
  const { t } = useLang();
  const items = t('portfolio.items') || [];

  return (
    <div data-testid="portfolio-page" className="relative pt-32 pb-24">
      <div className="absolute inset-0 bg-grid bg-grid-radial pointer-events-none opacity-40" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <FadeIn><SectionEyebrow>{t('portfolio.eyebrow')}</SectionEyebrow></FadeIn>
        <SectionTitle className="mt-3">{t('portfolio.title')}</SectionTitle>
        <FadeIn delay={0.2}><p className="mt-6 text-lg text-zinc-400 max-w-2xl">{t('portfolio.sub')}</p></FadeIn>

        <StaggerList delay={0.1} className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {Array.isArray(items) && items.map((it, i) => (
            <StaggerItem key={i}>
              <motion.a
                href="#"
                data-testid={`portfolio-item-${i}`}
                whileHover={{ y: -6 }}
                transition={{ duration: 0.4 }}
                className="tech-card group block relative overflow-hidden rounded-2xl border border-white/10 bg-zinc-950"
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <motion.img
                    src={COVERS[i % COVERS.length]}
                    alt={it.title}
                    whileHover={{ scale: 1.1 }}
                    transition={{ duration: 0.8 }}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6">
                  <p className="text-xs uppercase tracking-[0.2em] text-blue-400 heading-font font-bold mb-2">{it.cat}</p>
                  <div className="flex items-start justify-between gap-4">
                    <h3 className="heading-font text-xl md:text-2xl font-bold text-white">{it.title}</h3>
                    <ArrowUpRight className="w-5 h-5 text-zinc-500 group-hover:text-blue-400 group-hover:rotate-45 transition-all shrink-0 mt-1" />
                  </div>
                  <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{it.desc}</p>
                </div>
              </motion.a>
            </StaggerItem>
          ))}
        </StaggerList>
      </div>
    </div>
  );
};

export default PortfolioPage;
